import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { NgClass, NgIf } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { BooleanInput } from '@angular/cdk/coercion';
import { FuseConfigService } from '@fuse/services/config';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Navigation } from 'app/core/navigation/navigation.types';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { environment } from 'environments/environment';

@Component({
    selector       : 'user',
    templateUrl    : './user.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'user',
    standalone     : true,
    imports        : [MatButtonModule, MatMenuModule, NgIf, MatIconModule, NgClass, MatDividerModule, RouterModule],
})
export class UserComponent implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    public urlBase = environment.urlArchivos;
    userName: string = localStorage.getItem('user-name');
    userEmail: string = localStorage.getItem('user-email');
    userAvatar: string = localStorage.getItem('user-avatar');
    userID: string = localStorage.getItem('user-id');
    userType: string = localStorage.getItem('user-role');
    userState: string = localStorage.getItem('user-status');
    clientID: string = localStorage.getItem('user-client-id');

    navigation: Navigation;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _fuseConfigService: FuseConfigService,
        private _fuseNavigationService: FuseNavigationService
    )
    {
        this._fuseConfigService.config = {
            layout: 'modern'
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to user changes
        if (localStorage.getItem('user-surnames').indexOf(' ') !== -1){
            this.userName = this.userName + ' ' + localStorage.getItem('user-surnames').slice(0, localStorage.getItem('user-surnames').indexOf(' '));
        } else {
            this.userName = this.userName + ' ' + localStorage.getItem('user-surnames');
        }

        if (!localStorage.getItem('user-status')){
            localStorage.setItem('user-status', 'online');
            this.userState = 'online';
        }
        if (!localStorage.getItem('user-avatar') || localStorage.getItem('user-avatar') === 'null'){
            this.showAvatar = false;
        }

        if (this.userType === 'client'){
            this._fuseConfigService.config = {
                layout: 'classy'
            }
        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void
    {
        // Return if user is not available
        if ( !this.userState )
        {
            localStorage.setItem('user-status', 'online');
            this.userState = 'online';
        }

        localStorage.setItem('user-status', status);
        this.userState = status;
    }

    /**
     * Sign out
     */
    signOut(): void
    {
        this._router.navigate(['/sign-out']);
    }
}
